import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";






function PostCleaningSwapListings() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  // ================================
  // PRICING
  // ================================
  const [avgJobPrice, setAvgJobPrice] = useState("");


  // ================================
  // SWAP LOCATION (FROM / TO)
  // ================================
  const [swapFromSuburb, setSwapFromSuburb] = useState("");
  const [swapFromPostcode, setSwapFromPostcode] = useState("");
  const [swapFromState, setSwapFromState] = useState(""); // ✅ REQUIRED BY DB

  const [swapToSuburb, setSwapToSuburb] = useState("");
  const [swapToPostcode, setSwapToPostcode] = useState("");
  const [swapToState, setSwapToState] = useState("");

  // ================================
  // CLIENT OVERVIEW
  // ================================
  const [accessType, setAccessType] = useState("Access Available Anytime");
  const [streetParking, setStreetParking] = useState(false);
  const [petsAtHome, setPetsAtHome] = useState(false);
  const [alarmCodeRequired, setAlarmCodeRequired] = useState(false);
  const [homeSize, setHomeSize] = useState("");

  // ================================
  // SERVICE PREFERENCES
  // ================================
  const [serviceDay, setServiceDay] = useState("any");
  const [serviceTime, setServiceTime] = useState("any");

  // ================================
  // JOB DETAILS
  // ================================
  const [cleaningTime, setCleaningTime] = useState("");
  const [frequency, setFrequency] = useState("fortnightly");

  // ================================
  // AREAS SERVICED
  // ================================
  const [bedroomsCleaned, setBedroomsCleaned] = useState(1);
  const [bathroomsCleaned, setBathroomsCleaned] = useState(1);
  const [toiletsCleaned, setToiletsCleaned] = useState(1);
  const [kitchenIncluded, setKitchenIncluded] = useState(true);
  const [livingAreasIncluded, setLivingAreasIncluded] = useState(true);

  // ================================
  // ROUTINE CLEANING SERVICES
  // ================================
  const [services, setServices] = useState({
    dusting: true,
    vacuuming: true,
    mopping: true,
    surfacesWiped: true,
    tidying: true,
    kitchenCleaning: true,
    bathroomCleaning: true,
    bedMaking: false,
    linenChanging: false,
    washing: false,
    ironing: false,
    pantryTidying: false,
    loungeVacuum: false,
    cobwebRemoval: false,
    lightSpotCleaning: false,
    dishwashing: false,
    organisation: false,
  });

  const toggleService = (key) =>
    setServices((prev) => ({ ...prev, [key]: !prev[key] }));

  // ================================
  // SUBMIT
  // ================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));

      if (!user?.id) {
        setMessage("❌ You must be logged in to post a swap listing.");
        return;
      }

      const payload = {
        // 🔁 SWAP LOCATION
        swap_from_suburb: swapFromSuburb,
        swap_from_postcode: swapFromPostcode,
        swap_from_state: swapFromState,

        swap_to_suburb: swapToSuburb,
        swap_to_postcode: swapToPostcode,
        swap_to_state: swapToState,

        // 💰 PRICING
       avg_job_price:
  avgJobPrice !== "" ? Number(avgJobPrice) : null,


        // 🧹 JOB DETAILS
        frequency,
        cleaningTime: Number(cleaningTime),

        // 🏠 ACCESS
        accessType,
        streetParking: streetParking ? 1 : 0,
        petsAtHome: petsAtHome ? 1 : 0,
        alarmCodeRequired: alarmCodeRequired ? 1 : 0,
        homeSize,

        // 🛏️ AREAS
        bedroomsCleaned: Number(bedroomsCleaned),
        bathroomsCleaned: Number(bathroomsCleaned),
        toiletsCleaned: Number(toiletsCleaned),
        kitchenIncluded: kitchenIncluded ? 1 : 0,
        livingAreasIncluded: livingAreasIncluded ? 1 : 0,

        // 📅 SCHEDULE
        serviceDay,
        serviceTime,

        // 🧽 SERVICES
        services,

        // ✅ DISCLAIMER CONFIRMATION
  disclaimerAccepted,
      };

      const res = await fetch(
        `${API_BASE_URL}/api/cleaning/swap-listings/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

    const data = await res.json();

if (!res.ok) {
  setMessage(data.error || "❌ Failed to post swap listing");
  return;
}

setMessage("✅ Cleaning swap listing posted successfully! Redirecting...");

if (data.listingId) {
  setTimeout(() => {
    navigate(`/cleaning/swap-listing-success/${data.listingId}`);
  }, 1200);
} else {
  setTimeout(() => {
    navigate("/cleaning/swaps");
  }, 1200);
}
    } catch (err) {
      console.error(err);
      setMessage("❌ Server error. Please try again.");
    }
  };

  // ================================
  // UI
  // ================================
  return (
    <div style={container}>
      <h2 style={pageHeader}>Post Cleaning Swap Listing</h2>

      {message && <div style={messageBox}>{message}</div>}

      <form onSubmit={handleSubmit} style={form}>
        {/* PRICING */}
        <h3 style={sectionHeader}>Pricing</h3>
        <label style={labelBold}>Average Job Price ($)</label>
<input
  type="number"
  style={input}
  required
  placeholder="e.g. 85"
  value={avgJobPrice}
  onChange={(e) => setAvgJobPrice(e.target.value)}
/>


        {/* SWAP LOCATION */}
        <h3 style={sectionHeader}>Swap Location</h3>

        <label style={labelBold}>Current Suburb</label>
        <input style={input} required value={swapFromSuburb} onChange={(e) => setSwapFromSuburb(e.target.value)} />

        <label style={labelBold}>Current Postcode</label>
        <input style={input} required value={swapFromPostcode} onChange={(e) => setSwapFromPostcode(e.target.value)} />

        <label style={labelBold}>Current State</label>
        <select style={input} required value={swapFromState} onChange={(e) => setSwapFromState(e.target.value)}>
          <option value="">Select</option>
          {states.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <label style={labelBold}>Preferred Suburb</label>
        <input style={input} required value={swapToSuburb} onChange={(e) => setSwapToSuburb(e.target.value)} />

        <label style={labelBold}>Preferred Postcode</label>
        <input style={input} required value={swapToPostcode} onChange={(e) => setSwapToPostcode(e.target.value)} />

        <label style={labelBold}>Preferred State</label>
        <select style={input} required value={swapToState} onChange={(e) => setSwapToState(e.target.value)}>
          <option value="">Select</option>
          {states.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        {/* JOB DETAILS */}
        <h3 style={sectionHeader}>Job Details</h3>

        <label style={labelBold}>Cleaning Time</label>
        <select style={input} required value={cleaningTime} onChange={(e) => setCleaningTime(e.target.value)}>
          <option value="">Choose</option>
          <option value="0.5">30 Minutes</option>
          <option value="1">1 Hour</option>
          <option value="1.5">1.5 Hours</option>
          <option value="2">2 Hours</option>
          <option value="3">3 Hours</option>
        </select>

        <label style={labelBold}>Frequency</label>
        <select style={input} value={frequency} onChange={(e) => setFrequency(e.target.value)}>
          <option value="weekly">Weekly</option>
          <option value="fortnightly">Fortnightly</option>
           <option value="every_3_weeks">Every 3 Weeks</option>
          <option value="monthly">Monthly</option>
        </select>

        {/* SERVICE PREFERENCES */}
<label style={labelBold}>Preferred Day</label>
<select
  style={input}
  value={serviceDay}
  onChange={(e) => setServiceDay(e.target.value)}
>
  <option value="any">Any Day</option>
  <option value="monday">Monday</option>
  <option value="tuesday">Tuesday</option>
  <option value="wednesday">Wednesday</option>
  <option value="thursday">Thursday</option>
  <option value="friday">Friday</option>
  <option value="saturday">Saturday</option>
  <option value="sunday">Sunday</option>
</select>

<label style={labelBold}>Preferred Time</label>
<select
  style={input}
  value={serviceTime}
  onChange={(e) => setServiceTime(e.target.value)}
>
  <option value="any">Any Time</option>
  <option value="morning">Morning</option>
  <option value="midday">Midday</option>
  <option value="afternoon">Afternoon</option>
</select>

        {/* CLIENT OVERVIEW */}
        <h3 style={sectionHeader}>Client Overview</h3>

        <label style={labelBold}>Access Type</label>
        <select style={input} value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option>Access Available Anytime</option>
          <option>Key Safe</option>
          <option>Owner Home</option>
          <option>Tenant Home</option>
        </select>

        <Checkbox label="Street Parking" value={streetParking} setValue={setStreetParking} />
        <Checkbox label="Pets at Home" value={petsAtHome} setValue={setPetsAtHome} />
        <Checkbox label="Alarm Code Required" value={alarmCodeRequired} setValue={setAlarmCodeRequired} />

        {/* PROPERTY SIZE */}
        <h3 style={sectionHeader}>Property Size</h3>
        <Input label="Bedrooms" value={bedroomsCleaned} set={setBedroomsCleaned} />
        <Input label="Bathrooms" value={bathroomsCleaned} set={setBathroomsCleaned} />
        <Input label="Toilets" value={toiletsCleaned} set={setToiletsCleaned} />

        <Checkbox label="Kitchen Included" value={kitchenIncluded} setValue={setKitchenIncluded} />
        <Checkbox label="Living Areas Included" value={livingAreasIncluded} setValue={setLivingAreasIncluded} />

        {/* SERVICES */}
        <h3 style={sectionHeader}>Routine Cleaning Tasks</h3>
        {Object.keys(services).map((k) => (
          <Checkbox
            key={k}
            label={k.replace(/([A-Z])/g, " $1")}
            value={services[k]}
            setValue={() => toggleService(k)}
          />
        ))}

{/* DISCLAIMER */}
<div style={{
  marginTop: "20px",
  padding: "15px",
  backgroundColor: "#f9f9f9",
  borderRadius: "8px",
  border: "1px solid #ddd"
}}>
  <label style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
    <input
      type="checkbox"
      checked={disclaimerAccepted}
      onChange={(e) => setDisclaimerAccepted(e.target.checked)}
      required
      style={{ marginTop: "5px" }}
    />
    <span style={{ fontWeight: "bold" }}>I confirm that:</span>
  </label>

  <ul style={{
    fontSize: "0.9rem",
    color: "#333",
    marginTop: "10px",
    marginLeft: "30px",
    lineHeight: "1.6"
  }}>
    <li>All information provided is accurate and not misleading</li>
    <li>I am solely responsible for this listing</li>
    <li>Client Exchange™ does not verify or guarantee any listing information</li>
    <li>I have authority to transfer this cleaning client</li>
    <li>This does not breach any agreement (including franchise or contractual obligations)</li>
    <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
  </ul>

  <p style={{
    fontSize: "0.8rem",
    color: "#666",
    marginTop: "10px"
  }}>
    Listings must comply with any applicable agreements or obligations held by the seller.
  </p>
</div>


    <button
  type="submit"
  disabled={!disclaimerAccepted}
  style={{
    ...button,
    backgroundColor: !disclaimerAccepted ? "#9e9e9e" : "#2e7d32",
    cursor: !disclaimerAccepted ? "not-allowed" : "pointer",
  }}
>
  Post Swap Listing
</button>


      </form>
    </div>
  );
}

/* ================= COMPONENTS ================= */
const Input = ({ label, value, set }) => (
  <>
    <label style={labelBold}>{label}</label>
    <input style={input} type="number" value={value} onChange={(e) => set(e.target.value)} />
  </>
);

const Checkbox = ({ label, value, setValue }) => (
  <label style={checkboxRow}>
    <input type="checkbox" checked={!!value} onChange={(e) => setValue(e.target.checked)} />
    {label}
  </label>
);

/* ================= STYLES ================= */
const states = ["VIC","NSW","QLD","SA","WA","NT","TAS","ACT"];
const container = { maxWidth: 650, margin: "40px auto", padding: 25, background: "#fff", borderRadius: 12, boxShadow: "0 4px 15px rgba(0,0,0,0.15)" };
const pageHeader = { textAlign: "center", marginBottom: 25, color: "#2e7d32", fontWeight: "bold" };
const messageBox = { marginBottom: 20, textAlign: "center", fontWeight: 600 };
const form = { display: "flex", flexDirection: "column", gap: 20 };
const input = { padding: 10, borderRadius: 6, border: "1px solid #ccc" };
const labelBold = { fontWeight: "bold" };
const checkboxRow = { display: "flex", alignItems: "center", gap: 10 };
const sectionHeader = { borderBottom: "2px solid #4CAF50", paddingBottom: 6 };
const button = { padding: 14, background: "#2e7d32", color: "#fff", border: "none", borderRadius: 8, fontWeight: "bold" };

export default PostCleaningSwapListings;
